import { proxyCustomElement, HTMLElement, h, createEvent } from '@stencil/core/internal/client';
import { D as DomService, T as TrackingService } from './index3.js';
import { r as remCalc } from './index5.js';
import { a as ButtonAppearance, d as defineCustomElement$4 } from './roche-button2.js';
import { R as Ratio } from './roche-image.types.js';
import { T as TeaserLayout, a as Target } from './roche-teaser.types.js';
import { S as StringService } from './index2.js';
import { T as TranslationService } from './index6.js';
import { D as DownloadService } from './index12.js';
import { A as AdobeTracking } from './index7.js';
import { d as defineCustomElement$3 } from './roche-icon2.js';
import { d as defineCustomElement$1, a as defineCustomElement$2 } from './roche-image2.js';

const rocheTeaserCss = ":host{display:block;margin-top:3rem;display:block;margin-top:2rem;transform:translate3d(0, 0, 0)}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}:host .teaser{display:flex;flex-direction:column;height:100%;z-index:1}:host .teaser--card{padding:1.5rem;border:1px solid var(--color-border--default)}@media (min-width: 48rem){:host .teaser--card{padding:2rem}}:host .teaser__image{overflow:hidden}:host .teaser__image-wrapper{margin-bottom:1.5rem}:host .teaser__image-border{display:block;position:relative;border-bottom:0.25rem solid #c2bab5}:host .teaser__image-border::after{display:block;content:\"\";position:absolute;left:0;opacity:0;width:100%;transform-origin:left;transform:scaleX(0);border-bottom:0.25rem solid var(--color-interactive--primary-idle);transition:transform 400ms ease, opacity 400ms ease, border-color 400ms ease}:host .teaser__overline{padding:0;color:var(--color-text--primary);font-family:\"roche-sans\";font-style:normal;font-weight:400;font-size:1.125rem;line-height:1.6875rem;display:flex;color:#706b69;margin-bottom:0.25rem}:host .teaser__overline strong{font-weight:600}@media (min-width: 48rem){:host .teaser__overline{font-size:1.125rem;line-height:1.8125rem}}@media (min-width: 90rem){:host .teaser__overline{font-size:1.25rem;line-height:1.875rem}}:host .teaser__overline ::slotted([slot=overline]){margin:0 0 0 2rem}:host .teaser__title{padding:0;color:var(--color-text--primary);font-family:\"roche-sans\";font-style:normal;font-weight:400;font-size:1.5rem;line-height:1.9375rem;flex:1;align-self:flex-start;transition:color 200ms ease;word-break:break-word}:host .teaser__title strong{font-weight:600}@media (min-width: 48rem){:host .teaser__title{font-size:1.5rem;line-height:2.125rem}}@media (min-width: 90rem){:host .teaser__title{font-size:1.875rem;line-height:2.5625rem}}:host .teaser__title--download-link,:host .teaser__title--search-result{padding:0;color:var(--color-text--primary);font-family:\"roche-sans\";font-style:normal;font-weight:400;font-size:1.25rem;line-height:1.625rem}:host .teaser__title--download-link strong,:host .teaser__title--search-result strong{font-weight:600}@media (min-width: 48rem){:host .teaser__title--download-link,:host .teaser__title--search-result{font-size:1.25rem;line-height:1.875rem}}@media (min-width: 90rem){:host .teaser__title--download-link,:host .teaser__title--search-result{font-size:1.5rem;line-height:2.125rem}}:host .teaser__title-wrapper{display:flex;flex-flow:row nowrap;justify-content:flex-start}:host .teaser__title-wrapper roche-icon{display:flex;justify-content:center;align-items:flex-start;margin-left:auto;padding:0.25rem 1rem 0;fill:var(--color-interactive--primary-idle)}:host .teaser__author-description{margin:0.5rem 0 0;font-weight:400}:host .teaser__description{font-family:\"roche-sans\";font-style:normal;font-weight:200;color:var(--color-text--primary);font-size:var(--body--font-size--small-up);line-height:1.8125rem;flex:1;margin:0.5rem 0 0}@media (min-width: 64rem){:host .teaser__description{font-size:var(--body--font-size--xlarge-up);line-height:2rem}}:host .teaser__border{display:block;margin-top:auto;padding-top:1.875rem;position:relative;border-bottom:0.125rem solid #c2bab5}:host .teaser__border::after{display:block;content:\"\";position:absolute;left:0;opacity:0;width:100%;transform-origin:left;transform:scaleX(0);border-bottom:0.125rem solid var(--color-interactive--primary-idle);transition:transform 400ms ease, opacity 400ms ease, border-color 400ms ease}:host .teaser__link{display:flex;flex-direction:column;height:100%;color:inherit;text-decoration:none}:host .teaser__link:hover .teaser__border::after,:host .teaser__link:hover .teaser__image-border::after{opacity:1;transform:scaleX(1)}:host .teaser__link:hover .teaser__title{color:var(--color-interactive--primary-idle)}:host .teaser__link:focus-visible:focus,:host .teaser__link:focus-visible:focus-visible{outline:var(--color-interactive--primary-idle) dashed 2px;outline-offset:1}:host .teaser__link:focus-visible:focus:not(:focus-visible){outline:none}:host .teaser__link:focus:not(:focus-visible){outline:0}:host .teaser__buttons-wrapper-force-align-left{display:flex;margin:auto 0 0}:host .teaser__buttons-wrapper{display:flex;flex-direction:column;margin:auto 0 0}:host .teaser__buttons-wrapper roche-button{flex-grow:1;margin:1.5rem 0 0 0}:host .teaser__buttons-wrapper ::slotted([slot=secondary-action]){flex-grow:1;margin:0.5rem 0 0 0 !important}@media (min-width: 104.5rem){:host .teaser__buttons-wrapper ::slotted([slot=secondary-action]){margin-top:1.5rem !important}}@media (min-width: 104.5rem){:host .teaser__buttons-wrapper{flex-flow:row no-wrap}:host .teaser__buttons-wrapper roche-button,:host .teaser__buttons-wrapper ::slotted([slot=secondary-action]){flex-grow:0}:host .teaser__buttons-wrapper roche-button{margin:1.5rem 1rem 0 0}}:host roche-image{margin-top:0;transition:transform 600ms ease}:host([hidden]){display:none}:host([layout=teaser-variant-e]) .teaser__link:hover roche-image,:host([layout=teaser-variant-e-without-description]) .teaser__link:hover roche-image{transform:scale(1.03) !important}:host([unpublished=true]){background:rgba(255, 0, 0, 0.7);border:dashed maroon 1px}:host([is-teaser-in-draft=true]){display:none}:host([loaded]:not([loaded=false])) .teaser__link:hover roche-image{transform:scale(1.1)}:host([slot=quick-links]) .teaser__title{padding:0;color:var(--color-text--primary);font-family:\"roche-sans\";font-style:normal;font-weight:400;font-size:1.25rem;line-height:1.625rem}:host([slot=quick-links]) .teaser__title strong{font-weight:600}@media (min-width: 48rem){:host([slot=quick-links]) .teaser__title{font-size:1.25rem;line-height:1.875rem}}@media (min-width: 90rem){:host([slot=quick-links]) .teaser__title{font-size:1.5rem;line-height:2.125rem}}:host([slot=teasers]){margin-top:3rem}";
const RocheTeaserStyle0 = rocheTeaserCss;

const RocheTeaser = /*@__PURE__*/ proxyCustomElement(class RocheTeaser extends HTMLElement {
    componentDidRender() {
        this.teaserInit.emit(this);
    }
    get teaserImageElement() {
        const imageProps = this.isBrightcoveVideo() ? {
            brightcoveId: this.teaserImage,
        } : {
            src: this.teaserImage,
        };
        const ratio = this.verticalLayouts.includes(this.layout) ? Ratio.VERTICAL : Ratio.HD;
        // eslint-disable-next-line no-return-assign
        return this.teaserImage && h("div", { class: "teaser__image-wrapper" }, h("div", { class: "teaser__image" }, h("roche-image", Object.assign({ ratio: ratio }, imageProps))), h("span", { class: "teaser__image-border" }));
    }
    get teaserOverlineElement() {
        if (!this.hasSlottedOverlineContent && !this.teaserOverline) {
            return null;
        }
        return (h("div", { class: "teaser__overline" }, this.teaserOverline, h("slot", { name: "overline" })));
    }
    get teaserOverlinePublishedDateElement() {
        if (!this.hasSlottedOverlineContent && !this.teaserDate) {
            return null;
        }
        return (h("div", { class: "teaser__overline" }, this.teaserDate, h("slot", { name: "overline" })));
    }
    get teaserTitleElement() {
        const teaserTitleClassNames = {
            teaser__title: true,
            'teaser__title--download-link': this.isDownloadLink,
            'teaser__title--search-result': this.isSearchResult,
        };
        return this.teaserTitle && h("div", { class: "teaser__title-wrapper" }, h("div", { class: teaserTitleClassNames }, this.teaserTitle), !this.cardLayouts.includes(this.layout) && h("roche-icon", { icon: this.handleTeaserIcon(), height: `${remCalc(24)}rem` }));
    }
    get teaserDescriptionElement() {
        return this.teaserDescription && h("p", { class: "teaser__description" }, this.teaserDescription);
    }
    get teaserAuthorDescriptionElement() {
        return this.teaserAuthorDescription && h("p", { class: "teaser__author-description" }, this.teaserAuthorDescription);
    }
    get teaserButtonsElement() {
        const teaserButtonsWrapper = this.forceAlignLeft ? 'teaser__buttons-wrapper-force-align-left' : 'teaser__buttons-wrapper';
        return h("div", { class: teaserButtonsWrapper }, this.teaserUrl
            && h("roche-button", { appearance: ButtonAppearance.SECONDARY, text: StringService.capitalize(this.translations.readMore), href: this.teaserUrl, "no-margin": true, onClick: this.trackLinkClick }), h("slot", { name: "secondary-action" }));
    }
    get teaserElements() {
        return {
            [TeaserLayout.VARIANT_A]: [this.teaserImageElement, this.teaserOverlineElement,
                this.teaserTitleElement, this.teaserDescriptionElement],
            [TeaserLayout.VARIANT_B]: [this.teaserImageElement, this.teaserTitleElement,
                this.teaserDescriptionElement],
            [TeaserLayout.VARIANT_C]: [this.teaserImageElement, this.teaserOverlineElement,
                this.teaserTitleElement],
            [TeaserLayout.VARIANT_D]: [this.teaserImageElement, this.teaserTitleElement],
            [TeaserLayout.VARIANT_E]: [this.teaserImageElement, this.teaserTitleElement,
                this.teaserDescriptionElement],
            [TeaserLayout.VARIANT_E_WITHOUT_DESCRIPTION]: [this.teaserImageElement,
                this.teaserTitleElement],
            [TeaserLayout.VARIANT_A_WITHOUT_IMAGE]: [this.teaserOverlineElement, this.teaserTitleElement,
                this.teaserDescriptionElement, this.teaserBorderElement],
            [TeaserLayout.VARIANT_B_WITHOUT_IMAGE]: [this.teaserTitleElement, this.teaserDescriptionElement,
                this.teaserBorderElement],
            [TeaserLayout.VARIANT_C_WITHOUT_IMAGE]: [this.teaserOverlineElement, this.teaserTitleElement,
                this.teaserBorderElement],
            [TeaserLayout.VARIANT_D_WITHOUT_IMAGE]: [this.teaserTitleElement, this.teaserBorderElement],
            [TeaserLayout.VARIANT_C_WITHOUT_IMAGE_WITH_DATE]: [this.teaserOverlinePublishedDateElement,
                this.teaserTitleElement,
                this.teaserBorderElement],
            [TeaserLayout.CARD_A]: [this.teaserOverlineElement, this.teaserTitleElement,
                this.teaserDescriptionElement, this.teaserButtonsElement],
            [TeaserLayout.CARD_B]: [this.teaserTitleElement, this.teaserDescriptionElement,
                this.teaserButtonsElement],
            [TeaserLayout.CARD_C]: [this.teaserOverlineElement, this.teaserTitleElement,
                this.teaserButtonsElement],
            [TeaserLayout.RESULT]: [this.teaserOverlineElement, this.teaserTitleElement,
                this.teaserDescriptionElement, this.teaserBorderElement],
            [TeaserLayout.PUBMED]: [this.teaserOverlineElement,
                this.teaserTitleElement,
                this.teaserAuthorDescriptionElement,
                this.teaserDescriptionElement,
                this.teaserBorderElement],
        };
    }
    // eslint-disable-next-line class-methods-use-this
    get defaultTracking() {
        return {
            event: 'teaser_click',
            component_name: 'roche-teaser',
        };
    }
    async componentWillLoad() {
        this.translations = {
            readMore: await TranslationService.translate('read more'),
        };
        this.hasSlottedOverlineContent = !!this.element.querySelector('[slot="overline"]');
    }
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.teaserInit = createEvent(this, "rocheTeaserInit", 7);
        this.downloadEvent = createEvent(this, "triggerDownload", 7);
        this.cardLayouts = [TeaserLayout.CARD_A, TeaserLayout.CARD_B, TeaserLayout.CARD_C];
        this.verticalLayouts = [TeaserLayout.VARIANT_E, TeaserLayout.VARIANT_E_WITHOUT_DESCRIPTION];
        /**
         * The overline part of the teaser can be populated by both the
         * `teaserOverline` prop and the `overline` slot. The latter is meant for
         * developer use only. In particular, it allows to slot links (e.g. to
         * localized versions of the teaser content) that will work even when -- in
         * some layouts -- the containing teaser itself is a big anchor tag.
         */
        this.hasSlottedOverlineContent = false;
        this.teaserBorderElement = h("span", { class: "teaser__border" });
        this.layout = TeaserLayout.VARIANT_A;
        this.teaserImage = undefined;
        this.teaserTitle = undefined;
        this.teaserDescription = undefined;
        this.teaserDate = undefined;
        this.teaserAuthorDescription = undefined;
        this.teaserOverline = undefined;
        this.teaserUrl = undefined;
        this.isExternalLink = false;
        this.isDownloadLink = false;
        this.isSearchResult = false;
        this.target = Target.SELF;
        this.loaded = undefined;
        this.translations = undefined;
        this.forceAlignLeft = false;
        this.unpublished = false;
        this.isTeaserInDraft = false;
        this.onLinkClick = this.onLinkClick.bind(this);
    }
    render() {
        const teaserClassNames = {
            teaser: true,
            'teaser--card': this.cardLayouts.includes(this.layout),
        };
        return (h("div", { key: 'ca5f88f104bd50754546a091f6e758b8bf6a1fd5', class: teaserClassNames }, this.cardLayouts.includes(this.layout)
            ? this.teaserElements[this.layout]
            // eslint-disable-next-line react/jsx-no-target-blank
            : h("a", { href: this.teaserUrl, target: this.target, class: "teaser__link", onClick: this.onLinkClick }, this.teaserElements[this.layout])));
    }
    handleTeaserIcon() {
        if (this.isExternalLink) {
            return 'external-link';
        }
        if (this.isDownloadLink) {
            return 'download';
        }
        return 'arrow-right';
    }
    isBrightcoveVideo() {
        if (Number(this.teaserImage)) {
            return true;
        }
        return false;
    }
    onLinkClick(event) {
        if (this.isDownloadLink) {
            event.preventDefault();
            event.stopPropagation();
            if (DomService.getGlobalOnClickNotice()) {
                this.downloadEvent.emit({ url: this.teaserUrl });
                return;
            }
            DownloadService.handleDownload(this.teaserUrl);
            return;
        }
        // only track real user clicks
        if (event.isTrusted) {
            this.trackLinkClick();
        }
    }
    // eslint-disable-next-line class-methods-use-this
    get adobeTracking() {
        return {
            innerText: this.teaserTitle,
            url: this.teaserUrl,
            position: 'rocheTeaser',
            type: 'Teaser',
            socialMedia: '',
            socialInteraction: '',
        };
    }
    trackLinkClick() {
        var _a;
        TrackingService.push(Object.assign(Object.assign({}, this.defaultTracking), { additionalParameters: {
                teaser_title: this.teaserTitle,
                teaser_url: this.teaserUrl,
            } }));
        if (this.element.closest('.roche-search') || this.element.closest('roche-search') || this.element.closest('roche-search-list-container')) {
            const latestOnsiteSearchEvent = (window === null || window === void 0 ? void 0 : window.oneDataLayer) && (window === null || window === void 0 ? void 0 : window.oneDataLayer.filter((event) => event.event === 'onsiteSearch').pop()); // Get the latest onsiteSearch event
            // Extract the required properties using optional chaining
            const { term, results, filter, searchComponent, } = ((_a = latestOnsiteSearchEvent === null || latestOnsiteSearchEvent === void 0 ? void 0 : latestOnsiteSearchEvent.content) === null || _a === void 0 ? void 0 : _a.onsiteSearch) || {};
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.classList.add('active');
            const elementsInView = Array.from(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.parentElement.querySelectorAll('roche-teaser'));
            const activeElementIndex = elementsInView.findIndex((element) => element.classList.contains('active'));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.classList.remove('active');
            const searchElement = this.element.closest('.roche-search');
            const searchListContainer = this.element.closest('roche-search-list-container');
            let paginationResultsPerPage;
            if (searchElement) {
                const paginationElement = searchElement.querySelector('roche-pagination');
                paginationResultsPerPage = paginationElement
                    ? parseInt(paginationElement.getAttribute('data-rpp'), 10)
                    : elementsInView.length || 0;
            }
            else if (searchListContainer) {
                const paginationContainerElement = searchListContainer.querySelector('roche-pagination-container');
                paginationResultsPerPage = paginationContainerElement
                    ? parseInt(paginationContainerElement.getAttribute('data-rpp'), 10)
                    : elementsInView.length || 0;
            }
            else {
                paginationResultsPerPage = elementsInView.length || 0;
            }
            try {
                // Handle both external (absolute) and relative URLs
                const url = new URL(this.teaserUrl, window.location.origin);
                // Add the properties to the AdobeTracking call
                AdobeTracking(Object.assign(Object.assign({}, this.adobeTracking), { domain: url.host, path: url.pathname, name: this.teaserTitle, resultsPosition: (((filter === null || filter === void 0 ? void 0 : filter.pagination) - 1) * paginationResultsPerPage)
                        + activeElementIndex + 1, term,
                    results,
                    filter,
                    searchComponent }), 'onsiteSearchClick');
            }
            catch (error) {
                console.error('Error parsing URL:', error);
            }
        }
        else {
            AdobeTracking(this.adobeTracking, 'defaultLinkClick');
        }
    }
    get element() { return this; }
    static get style() { return RocheTeaserStyle0; }
}, [1, "roche-teaser", {
        "layout": [513],
        "teaserImage": [1, "teaser-image"],
        "teaserTitle": [1, "teaser-title"],
        "teaserDescription": [1, "teaser-description"],
        "teaserDate": [1, "teaser-date"],
        "teaserAuthorDescription": [1, "teaser-author-description"],
        "teaserOverline": [1, "teaser-overline"],
        "teaserUrl": [1, "teaser-url"],
        "isExternalLink": [4, "is-external-link"],
        "isDownloadLink": [4, "is-download-link"],
        "isSearchResult": [4, "is-search-result"],
        "target": [1],
        "loaded": [516],
        "forceAlignLeft": [4, "force-align-left"],
        "unpublished": [4],
        "isTeaserInDraft": [4, "is-teaser-in-draft"],
        "translations": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-teaser", "roche-button", "roche-icon", "roche-image", "roche-video-player"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-teaser":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheTeaser);
            }
            break;
        case "roche-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "roche-image":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "roche-video-player":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { RocheTeaser as R, defineCustomElement as d };

//# sourceMappingURL=roche-teaser2.js.map